import { useState, useContext, useEffect, useCallback } from 'react';
import { observer } from 'mobx-react-lite';

import Stack from '@mui/joy/Stack';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import FormHelperText from '@mui/joy/FormHelperText';
import Input from '@mui/joy/Input';
import Button from '@mui/joy/Button';
import Typography from '@mui/joy/Typography';
import Avatar from '@mui/joy/Avatar';
import { SvgIcon } from '@mui/material';
import Box from '@mui/joy/Box';
import AccountBoxIcon from '@mui/icons-material/AccountBox';


import { Identity } from 'stores/identity_store';
// import IdentityAvatar from 'components/IdentityAvatar';

import FakerAPI from 'api/faker';
import { RolesContext } from 'contexts/roles_context';
import { UserIdentityContext } from 'contexts/user_identity_context';

// import VerifiedIcon from '@mui/icons-material/Verified';
import Tooltip from '@mui/joy/Tooltip';
import { Success } from 'components/FancyToast';
import useAuth from 'hooks/useAuth';
// import FancyIcon from 'components/FancyIcon';
import { getIcon } from 'utils/misc';

const CreateIdentityIcon = AccountBoxIcon;


export type IdentityFormProps = {
	identity?: Identity,
    identities?: Identity[],
	selectedIdentity?: Identity,
	onChange: (e: Identity) => void
}



// const VerifiedIdentityStaticForm  = observer(({identity, clickEdit} : {identity: Identity, clickEdit: (_: boolean) => void }) =>  {
//     return (
//         <Card>
//             <Typography level="title-md">Your verified identity</Typography>
//             <IdentityAvatar interactive={false} size="default" identityKey={identity.key} />
//             <Button variant="plain" onClick={() => clickEdit(true)}>Edit</Button>
//         </Card>
//     );
// });


export const VerifiedIdentityForm = observer(({onSaveClick} : {onSaveClick: (identity: Identity) => void}) =>  {
    const { loadingIdentities, verifiedIdentity } = useContext(UserIdentityContext);
    const { currentUser } = useAuth();

    const [color, setColor] = useState('');
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [addr1, setAddr1] = useState('');
    const [addr2, setAddr2] = useState('');
    const [city, setCity] = useState('');
    const [state, setState] = useState('');
    const [zipcode, setZipcode] = useState('');
    const [identity, setIdentity] = useState<Identity>(verifiedIdentity);
    //    const [handle, setHandle] = useState('');

    const { rolesNames } = useContext(RolesContext)
    const EmailIcon = getIcon('ContactMail');
    const PhoneIcon = getIcon('LocalPhone');
    const Addr1Icon = getIcon('Home');
    const CityIcon = getIcon('LocationCity');
    const GlobeIcon = getIcon('Public');
    const ZipIcon = getIcon('MarkunreadMailboxOutlined');

    useEffect(() => {
        if(!loadingIdentities) {
            console.log("useEffect with verifiedIdentity", verifiedIdentity);
            setIdentity(verifiedIdentity);
            setName(verifiedIdentity.name);
            setEmail(verifiedIdentity.email);
            setPhone(verifiedIdentity.phone);
            setColor(verifiedIdentity.color);
            setAddr1(verifiedIdentity.addr1);
            setAddr2(verifiedIdentity.addr2);
            setCity(verifiedIdentity.city);
            setState(verifiedIdentity.state);
            setZipcode(verifiedIdentity.zipcode);
        }
    }, [verifiedIdentity, loadingIdentities]);


    // set the default info
    useEffect(() => {
        if(loadingIdentities) {
            return;
        }
        if(!name) {
            if(currentUser?.name) {
                setName(currentUser?.name);
            }
            else if(currentUser.first_name && currentUser.last_name) {
                setName(currentUser.first_name + ' ' + currentUser.last_name);
            }
        }
        if (!email) {
            if(currentUser.primary_email) {
                setEmail(currentUser.primary_email);
            }
        }
        // onChange({ ...verifiedIdentity, name: name, email: email } as Identity);
    }, [currentUser, loadingIdentities]);


    useEffect(() => {
        if(rolesNames.length === 0) {
            return;
        }
        if(loadingIdentities) {
            return;
        }
        const role = rolesNames.includes('client') ? 'client' : 'assistant';

        setIdentity(
            {
                verified: 'requested',
                name: name,
                // handle: handle,
                email: email,
                color: color,
                phone: phone,
                addr1: addr1,
                addr2: addr2,
                city: city,
                state: state,
                zipcode: zipcode,
                key: verifiedIdentity?.uuid ? verifiedIdentity.uuid : 'create-me',
                role: !identity.role ? role : identity.role } as Identity
            );


    }, [loadingIdentities, name, color, email, phone, addr1, addr2, city, state, zipcode, rolesNames]);



    // function updateHandle(s: string) {
    //     const handle = s.replace(/[^a-zA-Z0-9]/g, '');
    //     setHandle(handle);
    //     return handle;
    // }

    if(loadingIdentities) {
        return <em>Loading verified</em>;
    }

    return (
                <Stack>
            <Stack spacing={2}>

                {/*
                <Stack direction="row">
                    <Tooltip arrow
                        placement="top"
                        title="We'll verify your identity (for free)">
                        <Typography
                            startDecorator={<VerifiedIcon color="primary" />}
                        > Verified Identity
                        </Typography>
                    </Tooltip>
                </Stack>
                  */}
                <FormControl>
                    <FormLabel><CreateIdentityIcon /> Name</FormLabel>
                    <Stack direction="row" spacing={1}>
                        <AvatarColorPicker
                            color={color}
                            setColor={(e) => setColor(e)} />

                        <Input
                            sx={{width: '100%'}}
                            onChange={(e) => { setName(e.target.value); }}
                            value={name}
                            name="anything_but"
                            type="anything_but"
                            placeholder="First Last"
                        />
                    </Stack>


                    <FormHelperText>
                        <Typography level='body-xs'>
                            Short names are fine: {' '}
                            <em>Betsy</em> instead of <em>Elizabeth</em> or {' '}

                            <em>Shaq</em> instead of <em>Shaquille</em>.
                        </Typography>

                    </FormHelperText>

                </FormControl>

                {/*
                <FormControl>
                    <FormLabel><FancyIcon name="DayOnesChat" /> How will you be known in chat?</FormLabel>

                <Input
                                value={handle}
                                startDecorator={<FancyIcon name="DayOnesChat" />}
                                onChange={(e) => updateHandle(e.target.value)}
                    />
                    </FormControl>
                  */}
                <FormControl>
                    <FormLabel><EmailIcon /> Email</FormLabel>

                    <Input
                        sx={{width: '100%'}}
                        onChange={(e) => { setEmail(e.target.value); }}
                        value={email}
                        name="email_but"
                        type="email_but"
                        placeholder="Email Address"
                    />

                </FormControl>



                <FormControl>
                    <FormLabel><PhoneIcon /> Phone</FormLabel>
                    <Input
                        sx={{width: '100%'}}
                        onChange={(e) => { setPhone(e.target.value); }}
                        value={phone}
                        name="phone"
                        type="phone"
                        placeholder="Phone Number"
                    />
                </FormControl>

                <FormControl>
                    <FormLabel><Addr1Icon /> Address</FormLabel>
                    <Input
                        sx={{width: '100%'}}
                        onChange={(e) => { setAddr1(e.target.value); }}
                        value={addr1}
                        name="addr1"
                        type="addr1"
                        placeholder="Street Address"
                    />
                </FormControl>

                <FormControl>
                    <Input
                        sx={{width: '100%'}}
                        onChange={(e) => { setAddr2(e.target.value); }}
                        value={addr2}
                        name="addr2"
                        type="addr2"
                        placeholder="Street Address (Additional)"
                    />
                </FormControl>

                <FormControl>
                    <FormLabel><CityIcon /> City</FormLabel>
                    <Input
                        sx={{width: '100%'}}
                        onChange={(e) => { setCity(e.target.value); }}
                        value={city}
                        name="city"
                        type="city"
                        placeholder="City"
                    />
                </FormControl>

                <Stack direction={{xs: "column", sm:"row"}}
                    spacing={2}
                    justifyContent="space-between"
                    sx={{with: '100%'}}
                >
                    <FormControl
                        sx={{width: '100%'}}
                    >
                        <FormLabel><GlobeIcon /> State</FormLabel>
                        <Input
                            sx={{width: '100%'}}
                            onChange={(e) => { setState(e.target.value); }}
                            value={state}
                            name="state"
                            type="state"
                            placeholder="State"
                        />
                    </FormControl>
                    <FormControl
                        sx={{width: '100%'}}
                    >
                        <FormLabel><ZipIcon /> Zip</FormLabel>
                        <Input
                            sx={{width: '50%'}}
                            onChange={(e) => { setZipcode(e.target.value); }}
                            value={zipcode}
                            name="zipcode"
                            type="zipcode"
                            placeholder="Zip"
                        />
                    </FormControl>
                </Stack>
            </Stack>

                    <Stack flexGrow={1} my={2} >
                    <Button
                        variant="solid"
                        color="primary"
                        onClick={() => { onSaveClick(identity); }}>
                        Save
                    </Button>
                </Stack>
                </Stack>
    );

});


function AvatarColorPicker( {color, setColor} : {color: string, setColor: (color: string) => void}) {
    const [didRandom, setDidRandom] = useState(false);

    const randomColor = useCallback(() => {

        FakerAPI.getColor()
            .then((data) => {
                // console.log("got it, setting color");
                setColor(data.color);
            });
    }, [setColor]);

    useEffect(() => {
        if(!didRandom && !color) {
            // console.log("doing random set for %s" , color);
            setDidRandom(true);
            randomColor();
        }
    }, [didRandom, randomColor, color]);

    return (
            <Button
            component="label"
            tabIndex={-1}
            role={undefined}
            aria-label="color"
            variant="outlined"
            color="neutral"
            endDecorator={
                <SvgIcon >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={2}
                        stroke="currentColor"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                        />
                    </svg>
                </SvgIcon>
            }
            sx={{ pl: 1 }}
            >

                <Tooltip title="Tip: Right-click here a random color">
            <Avatar
                onContextMenu={(e) => { e.preventDefault();
                    randomColor();
                    Success('Loading random color'); }}
                sx={{ width: 32, height: 32, bgcolor: color }} >
            </Avatar></Tooltip>
            <Box
                component="input"
                type="color"
                value={color}
                onChange={(event) => setColor(event.target.value)}
                sx={{
                    clip: 'rect(0 0 0 0)',
                    clipPath: 'inset(50%)',
                    height: '1px',
                    overflow: 'hidden',
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    whiteSpace: 'nowrap',
                    width: '1px',
                }}
            />
        </Button>
    );
}
export const NewIdentityForm = observer(({ onChange } : IdentityFormProps) => {

	const [color, setStateColor] = useState('');
	const [name, setStateName] = useState('');

    const [error, setError] = useState('');


	function setName(name: string) {
		setStateName(name);
        onChange({name: name} as Identity);
	}

	function setColor(color: string) {
		setStateColor(color);
        onChange({color: color} as Identity);
	}

	function randomName() {
		FakerAPI.getName("")
			.then((name) => {
				const n = name.first + ' ' + name.last;
				setName(n);
			})
            .catch((err) => {
                setError("Error getting name");
                console.log("Error getting name: %o", err);
            });
    }



	return (
        <>
            { error && <Typography level="body-sm" color="danger">{error}</Typography> }
            <FormControl>
                <FormLabel>Create a new Identity</FormLabel>
            </FormControl>
            <FormControl>
                <FormLabel><CreateIdentityIcon /> Name</FormLabel>
                <Stack direction="row" spacing={1} >
                    <AvatarColorPicker color={color} setColor={setColor} />
                    <Input
                        sx={{ width: "100%" }}
                        onChange={(e) => { setName(e.target.value); }}
                        value={name}
                        name="anything_but"
                        type="anything_but"
                        placeholder="Who are you now?"
                    />
                    <Button size="sm" variant="plain"
                        onClick={() => randomName()}>Generate Name</Button>
                </Stack>
                <FormHelperText>The name your collaborators will see.</FormHelperText>
            </FormControl>
        </>
	)
});
